import { Sites } from "bx-react-ui/src/utils/sites";
import { callApi } from "../api";

export const fetchForgotPassword = (username) => {
  const body = {
    username: username,
    siteFrom: Sites.bxdigital,
  };
  return callApi("users/ForgotPassword", body, "POST");
};

export const fetchResetPassword = (username, newPassword, token) => {
  const body = {
    username: username,
    newPassword: newPassword,
    token: token,
  };
  return callApi("users/ResetPassword", body, "POST");
};

export const fetchChangePassword = (oldPassword, newPassword) => {
  const body = {
    oldPassword: oldPassword,
    newPassword: newPassword,
  };
  return callApi("users/changePassword", body, "POST");
};

export const fetchSendContactRequest = (site, senderName, senderMail, message) => {
  const body = {
    site,
    senderName,
    senderMail,
    message,
  };
  return callApi("contact", body, "POST");
};

export const fetchLastLogin = () => {
  return callApi("user/lastLogin", undefined, "GET");
};
